import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed, onMounted } from 'vue';
import { useUiStore } from '@/stores/ui';
import appuserapi from '@/api/appuserapi';
import { createReferenceSheetTitle } from '@/functions/resultSuggestion.js';
import { useI18n } from "vue-i18n";
type RefSheetSelection = {
  id: string | number
  name: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'searchRefSheet',
  props: {
    autofocus: { type: Boolean, default: false }
  },
  emits: ["afterSelect", "afterCreateNew"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const uiStore = useUiStore();

const emits = __emit

const props = __props;

const focusRef = ref(null);
const searchContent = ref("");
const refSheetGroups = ref([]);
const selectedName = ref("");

async function initialize() {
  const allRefSheets = await appuserapi.allReferenceSheetsToDto();
  refSheetGroups.value = createRefSheetGroups(allRefSheets);
  if (props.autofocus) {
    focusRef.value?.innerRef?.focus();
  }
}

const filteredRefSheetGroups = computed(() => {
  const groups = refSheetGroups.value;
  const searchString = searchContent.value.trim().toLowerCase();
  if (searchString.length <= 1) return groups;
  return groups.filter(group => {
    return group.title.toLowerCase().startsWith(searchString) || group.trigger.toLowerCase().startsWith(searchString)
  });
})

async function setRefSheet(refSheet) {
  const refSheetId = refSheet.appUserResultReferenceId;
  const fullRefSheet = await appuserapi.getRefSheet(refSheetId);
  const keywords = createReferenceSheetTitle(fullRefSheet);
  uiStore.setReferenceSearchKewords(keywords);
  uiStore.setCurrRefSheet(fullRefSheet);

  selectedName.value = keywords;
  searchContent.value = keywords;

  emits('afterSelect', {
    id: refSheetId,
    name: keywords,
  });
}

const showCreateOption = computed(() => {
  const searchString = searchContent.value.trim().toLowerCase();
  if (!searchString) return false;
  const hasExactMatch = refSheetGroups.value.some(group =>
    group.title.toLowerCase() === searchString ||
    group.trigger.toLowerCase() === searchString
  );
  return !hasExactMatch;
})

async function createNewRefSheet() {
  const newTitle = searchContent.value.trim();
  if (!newTitle) return;
  const newRefSheet = await appuserapi.addRefSheet(newTitle);
  const keywords = createReferenceSheetTitle(newRefSheet);
  uiStore.setReferenceSearchKewords(keywords);
  uiStore.setCurrRefSheet(newRefSheet);

  selectedName.value = keywords;
  searchContent.value = keywords;

  emits('afterCreateNew', {
    id: newRefSheet.appUserResultReferenceId,
    name: keywords,
  });
}

function onInputFocus() {
  if (searchContent.value === selectedName.value) {
    searchContent.value = "";
  }
}

function onInputBlur() {
  if (!searchContent.value.trim() && selectedName.value) {
    searchContent.value = selectedName.value;
  }
}

function createRefSheetGroups(allRefSheets) {
  const arrangedList = allRefSheets.flatMap(refSheet => {
    const triggerArr = refSheet.triggers.split('\n')
    const title = triggerArr[0]
    return triggerArr.map(trigger => ({
      refSheet,
      title,
      trigger,
    }))
  })
  arrangedList.sort((a, b) => a.trigger.localeCompare(b.trigger))
  return arrangedList
}

onMounted(() => {
  initialize()
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!

  return (_openBlock(), _createBlock(_component_inputComboBox2, {
    ref_key: "focusRef",
    ref: focusRef,
    modelValue: searchContent.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchContent).value = $event)),
    onFocus: onInputFocus,
    onBlur: onInputBlur
  }, {
    dropd: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRefSheetGroups.value, (refSheetGroup, index) => {
        return (_openBlock(), _createBlock(_component_list_group, {
          key: index,
          styles: "pad-s",
          onClick: ($event: any) => (setRefSheet(refSheetGroup.refSheet))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: refSheetGroup.trigger,
              class: "mleft-06 col-width"
            }, null, 8, ["txt"]),
            _createVNode(_component_svg_item, {
              icon: "bookOpen",
              styles: "main-l",
              class: "mleft-10 mtop-01"
            }),
            _createVNode(_component_text_item, {
              txt: refSheetGroup.title,
              styles: "main-m",
              class: "mleft-04 col-width"
            }, null, 8, ["txt"])
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128)),
      (showCreateOption.value)
        ? (_openBlock(), _createBlock(_component_list_group, {
            key: 0,
            styles: "pad-s",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (createNewRefSheet()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('action.create'),
                styles: "font-m",
                class: "mleft-06 col-width align-r"
              }, null, 8, ["txt"]),
              _createVNode(_component_svg_item, {
                icon: "book",
                styles: "main-l",
                class: "mleft-10 mtop-01"
              }),
              _createVNode(_component_text_item, {
                txt: searchContent.value,
                styles: "main-m",
                class: "mleft-04 col-width"
              }, null, 8, ["txt"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})